export const DefinitionsActionTypes = {
  SET_STEP1: 'SET_STEP1',
  SET_STEP2: 'SET_STEP2',
  SET_STEP3: 'SET_STEP3',
  SET_STEP4: 'SET_STEP4',
  SET_STEP5: 'SET_STEP5'
}